import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import MarkupListLayer from "../../components/Markup/MarkupListLayer";

const MarkupListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Markups Control" />

        <MarkupListLayer />
      </MasterLayout>
    </>
  );
};

export default MarkupListPage;
